import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
const getOrgAdById = (id) => {
    let reqid=id
    const token=getTokenfromUserObj()
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const getData = async (id) => {
          try {
            const res = await axios.get(`${app.URL}/orgad/viewad/${id}`,{headers:{auth:token}});
            console.log(res);
            setResponse(res.data);
            setLoading(false);
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        getData(reqid);
      }, []);
    
      return { loading, response, error };
    };
export default getOrgAdById